import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';

const json = {
  1: { // Exercise num
    unit: 'Unit 5',
    id: 'SB4-U5-P41-E1',
    audio: 'img/FriendsPlus/Page41/Audio/audio-e1-p41.mp3',
    video: '',
    maxLength: 1,
    padding: 0,
    textAlign: 'center',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page41/E1/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page41/E1/1.jpg' },
        { url: 'img/FriendsPlus/Page41/E1/2.jpg', audioUrl: 'img/FriendsPlus/Page41/Audio/tieude-e1-p41.mp3' },
        { url: 'img/FriendsPlus/Page41/E1/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page41/E1/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page41/E1/5.jpg' },
        { url: 'img/FriendsPlus/Page41/E1/6.jpg', input: true, answer: "2" },
        { url: 'img/FriendsPlus/Page41/E1/7.jpg' },
        { url: 'img/FriendsPlus/Page41/E1/8.jpg', input: true, answer: "4" },
        { url: 'img/FriendsPlus/Page41/E1/9.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page41/E1/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page41/E1/11.jpg' },
        { url: 'img/FriendsPlus/Page41/E1/12.jpg', input: true, answer: "3" },
        { url: 'img/FriendsPlus/Page41/E1/13.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page41/E1/14.jpg' },
      ],

    ],
  },
  2: { // Exercise num
    unit: 'Unit 5',
    id: 'SB4-U5-P41-E2',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    questionImage: [ // Row
      [
        // Column1

        { url: 'img/FriendsPlus/Page41/E2/1.jpg' },
      ]
    ],
  },
  3: { // Exercise num
    unit: 'Unit 5',
    id: 'SB4-U5-P41-E3',
    audio: '',
    video: '',
    component: UI,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page41/E3/1.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page41/E3/2.jpg' },
      ]
    ],
  },
  4: { // Exercise num
    unit: 'Unit 5',
    id: 'SB4-U5-P41-E4',
    audio: '',
    video: '',
    component: D1,
    hideBtnFooter: true,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page41/E4/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page41/E4/2.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page41/E4/3.jpg' },
        { url: 'img/FriendsPlus/Page41/E4/4.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page41/E4/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page41/E4/6.jpg' },
        { url: 'img/FriendsPlus/Page41/E4/7.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page41/E4/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page41/E4/9.jpg' },
        { url: 'img/FriendsPlus/Page41/E4/10.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page41/E4/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page41/E4/12.jpg' },
      ],

    ],
  },

}

export default json;